// extracted by mini-css-extract-plugin
module.exports = {"alertText":"clinical-portal-3__PatientAlertsSection__alertText","lastUpdated":"clinical-portal-3__PatientAlertsSection__lastUpdated"};